import React from 'react';
import { useWatch } from 'react-hook-form';
import { defaultProduct } from '../../forms/drivingPermit/DrivingPermit';
import { FunnelSummary } from './FunnelSummary';
import { ReceiptSummary } from './ReceiptSummary';
import { SummaryProps, SummaryProviderProps } from './Summary.utils';

export { FunnelSummary } from './FunnelSummary';
export { ProductTitle } from './ProductTitle';
export { ReceiptSummary } from './ReceiptSummary';

export const Summary = ({ products, orderSummaries, grandTotal, useOriginalPrice = false }: SummaryProps) => {
  if (orderSummaries) {
    return <ReceiptSummary orderSummaries={orderSummaries} grandTotal={grandTotal} />;
  }

  return <FunnelSummary products={products} useOriginalPrice={useOriginalPrice} />;
};

export const SummaryProvider = ({ control: formController, useOriginalPrice = false }: SummaryProviderProps) => {
  const products = useWatch({
    control: formController,
    name: 'product', // without supply name will watch the entire form, or ['firstName', 'lastName'] to watch both
    defaultValue: defaultProduct, // default value before the render
  });

  return <Summary products={products} useOriginalPrice={useOriginalPrice} />;
};
